<template>
  <div class="modal__content">
    <div class="image_onboarding_first_digital">
      <FirtsImageOnBoarding />
    </div>
    <div class="content_onboarding_employee_first_step">
      <div class="container_onboarding_title">
        <div class="title_onboarding_assistance ">
          ¡Bienvenido a tu Firma digital!
        </div>
      </div>
      <div class="text_container_onboarding text_first_assistance">
        <div class="">
          En esta sección podrás firmar electrónicamente todos tus documentos,
          sean internos o externos a la plataforma.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FirtsImageOnBoarding from "./assets/firstStepDigital.svg";
import { mapGetters } from "vuex";
export default {
  props: ["size"],
  components: {
    FirtsImageOnBoarding,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters("DigitalSignature", {
      stepDigitalOnBoarding: "stepDigitalOnBoarding",
    }),
  },

  methods: {
    AcceptOnBoarding() {
      let increment = this.stepDigitalOnBoarding + 1;

      this.$store.dispatch(
        "DigitalSignature/counterStepDigitalOnBoarding",
        increment
      );
    },
    cancelModal() {
      let modal = document.querySelector(
        "#modal__onboarding__digital__signature"
      );
      modal.setAttribute("closing", "");
      modal.addEventListener(
        "animationend",
        () => {
          modal.removeAttribute("closing");
          modal.close();
        },
        { once: true }
      );
    },
  },
};
</script>

<style lang="scss">
.text_first_assistance {
  gap: 5rem !important;
}
.title_onboarding_assistance {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 49px;
  margin-top: 3rem !important;

  @media screen and (max-width: 500px) and (min-width: 200px) {
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 39px;
  }
}
.image_onboarding_first_digital {
  width: 339px !important;
  height: 300px !important;
  display: flex;
  margin-top: 5.5rem;
  margin-left: 10.5rem !important;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 500px) and (min-width: 200px) {
    width: 250px !important;
    height: 200px !important;
    margin-left: 2rem !important;
    margin-top: 3rem !important;
  }
}
</style>
